<td>{{ audit.createdAt | date: 'M/d/yyyy h:mm a' }}</td>
<td>Added Note To {{ modelHumanizedName }}</td>
<td>
  <div class="overflow-auto" style="max-height: 600px;" [innerHTML]="newValueHtml"></div>
</td>
<td>--</td>
<td>{{ audit.user?.email | blankValueDash }}</td>